import { DesktopChat } from '../components/chat/DesktopChat';

export function ChatPage() {
	return <DesktopChat />;
}
